 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import { useEffect} from 'react'
import {BezierCurve, Breakpoint, DiscussionThreadEnum, NavSidebar} from '~/types/constEnums'
import useResizeObserver from './useResizeObserver'










const coverables = {} 
const covering = {el: null, left: 0, right: 0} 





const ensureCovering = (
  coverable,
  leftBound,
  rightBound,
  isDrag
) => {
  if (!coverable.el) return
  const willBeExpanded = coverable.left > rightBound || coverable.right < leftBound ? true : false
  const height = willBeExpanded ? '100%' : `calc(100% - ${coverable.height}px)`
  const {style} = coverable.el
  style.height = height
  if (isDrag) {
    style.transition = `all 100ms ${BezierCurve.DECELERATE}`
  }
  coverable.isExpanded = willBeExpanded
}

export const useCoverable = (
  id,
  ref,
  height,
  parentRef,
  columnsRef,
  isDrawer
) => {
  const updateCoverables = () => {
    if (isDrawer) return
    const el = ref.current
    if (!el) return
    if (window.innerWidth < Breakpoint.SINGLE_REFLECTION_COLUMN) return
    const bbox = el.getBoundingClientRect()
    const {left, right} = bbox
    const oldCoverable = coverables[id]
    const BUFFER = 8
    const coverable = {
      id,
      el,
      height,
      left: left - BUFFER,
      right: right + BUFFER,
      isExpanded: _nullishCoalesce(_optionalChain([oldCoverable, 'optionalAccess', _ => _.isExpanded]), () => ( false))
    }
    if (covering.el) {
      cacheCoveringBBox()
      ensureCovering(coverable, covering.left, covering.right)
    }
    coverables[id] = coverable
  }

  useResizeObserver(updateCoverables, parentRef)
  useResizeObserver(updateCoverables, columnsRef)

  useEffect(() => {
    updateCoverables()
    return () => {
      const oldCoverable = coverables[id]
      if (oldCoverable) {
        ;(oldCoverable ).el = null
      }
    }
  }, [])

  if (isDrawer) return true
  return _nullishCoalesce(_optionalChain([coverables, 'access', _2 => _2[id], 'optionalAccess', _3 => _3.isExpanded]), () => ( false))
}

export const ensureAllCovering = (leftBound, rightBound) => {
  Object.values(coverables).forEach((coverable) => {
    ensureCovering(coverable, leftBound, rightBound, true)
  })
}

export const cacheCoveringBBox = (isLeftSidebarOpen, isRightDrawerOpen) => {
  if (covering.el) {
    const coveringBBox = covering.el.getBoundingClientRect()
    const {left, right} = coveringBBox
    covering.left = left - (isLeftSidebarOpen ? NavSidebar.WIDTH : 0)
    covering.right = right + (isRightDrawerOpen ? DiscussionThreadEnum.WIDTH : 0)
  }
  return covering
}

export const useCovering = (ref) => {
  useEffect(() => {
    const el = ref.current
    if (!el) return
    covering.el = el
    if (Object.keys(coverables).length) {
      cacheCoveringBBox()
    }
    ensureAllCovering(covering.left, covering.right)
    return () => {
      covering.el = null
    }
  }, [])
}
